import Model from './model'

export default class Company extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/company'
    }
}
